module.exports = __webpack_public_path__ + "images/emoji/rowboat.be1625a6e4a157a51dd3.png";